module.exports = __webpack_public_path__ + "static/media/pn-pc-red.a7ba368f.svg";